import {registerRoute as workbox_routing_registerRoute} from '/home/vsts/work/1/s/ui-user-management/node_modules/.pnpm/workbox-routing@6.6.0/node_modules/workbox-routing/registerRoute.mjs';
import {CacheFirst as workbox_strategies_CacheFirst} from '/home/vsts/work/1/s/ui-user-management/node_modules/.pnpm/workbox-strategies@6.6.0/node_modules/workbox-strategies/CacheFirst.mjs';
import {clientsClaim as workbox_core_clientsClaim} from '/home/vsts/work/1/s/ui-user-management/node_modules/.pnpm/workbox-core@6.6.0/node_modules/workbox-core/clientsClaim.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/home/vsts/work/1/s/ui-user-management/node_modules/.pnpm/workbox-precaching@6.6.0/node_modules/workbox-precaching/precacheAndRoute.mjs';
import {NavigationRoute as workbox_routing_NavigationRoute} from '/home/vsts/work/1/s/ui-user-management/node_modules/.pnpm/workbox-routing@6.6.0/node_modules/workbox-routing/NavigationRoute.mjs';
import {createHandlerBoundToURL as workbox_precaching_createHandlerBoundToURL} from '/home/vsts/work/1/s/ui-user-management/node_modules/.pnpm/workbox-precaching@6.6.0/node_modules/workbox-precaching/createHandlerBoundToURL.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








self.skipWaiting();

workbox_core_clientsClaim();


/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "index.html",
    "revision": "d89f572522c250fdce8f56d27a121caf"
  },
  {
    "url": "ui-user-management.js",
    "revision": "07086445f035503c243ff08f0fae5365"
  },
  {
    "url": "ui-user-management2.js",
    "revision": "316ac10fe8019571dfa5a19b236f7851"
  },
  {
    "url": "ui-user-management3.js",
    "revision": "b20607b1c178e0996b0e050bb382822d"
  },
  {
    "url": "ui-user-management4.js",
    "revision": "2621a040807bc53b1b8f8bef6d26aab5"
  },
  {
    "url": "ui-user-management5.js",
    "revision": "1d60f32bc9923e5f21c4651eb85a6913"
  },
  {
    "url": "ui-user-management6.js",
    "revision": "747c1928d8fbf504cc65d153f2318449"
  }
], {});

workbox_routing_registerRoute(new workbox_routing_NavigationRoute(workbox_precaching_createHandlerBoundToURL("/index.html")));


workbox_routing_registerRoute("polyfills/*.js", new workbox_strategies_CacheFirst(), 'GET');




